import { atom } from "recoil";

export const photoIdState = atom({
  key: "photoIdState",
  default: "",
});

export const userIdState = atom({
  key: "userIdState",
  default: "",
});

export const commentIdState = atom({
  key: "commentIdState",
  default: "",
});